import { Link } from 'react-router-dom';
import { Camera, ImageOff } from 'lucide-react';
import { useAlbums } from '../lib/queries';

export default function Photos() {
  const { data: albums, isLoading } = useAlbums();

  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-serif text-primary mb-2">Foto</h1>
      <p className="text-ink-muted mb-8">Album från Stamlogen 2026</p>

      {isLoading ? (
        <p className="text-ink-muted">Laddar…</p>
      ) : !albums || albums.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 shadow-sm text-center">
          <ImageOff className="mx-auto mb-3 text-ink-disabled" size={48} />
          <p className="text-ink-muted">Inga album än.</p>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {albums.map((album) => (
            <Link
              key={album.id}
              to={`/foto/${album.id}`}
              className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
            >
              {album.coverThumbUrl ? (
                <div className="aspect-video bg-surface-cream overflow-hidden">
                  <img
                    src={album.coverThumbUrl}
                    alt={album.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <div className="aspect-video bg-surface-cream flex items-center justify-center">
                  <Camera className="text-primary/30" size={48} />
                </div>
              )}
              <div className="p-4">
                <h2 className="font-serif text-xl text-primary mb-1">{album.name}</h2>
                {album.description && (
                  <p className="text-ink-muted text-sm line-clamp-2 mb-2">{album.description}</p>
                )}
                <p className="text-xs text-ink-disabled">{album.photoCount} foton</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
